// extracted by mini-css-extract-plugin
export default {"cls1":"VeloStepperText-Text_cls1__3YI1N","cls2":"VeloStepperText-Text_cls2__wJgDC VeloStepperText-Text_cls1__3YI1N","disabled":"VeloStepperText-Text_disabled__ps-F2"};